import React, { memo, useRef } from 'react';
import type { BaseHit } from 'instantsearch.js';
import algoliasearchHelper from 'algoliasearch-helper';
import { Category, M20CategoriesModule } from '~/lib/data-contract';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import CategoryCarousel from './CardCarousel/CardCarousel';

export type CardProps = {
    item: Category;
    className?: string;
    priority?: boolean;
    largePadding?: boolean;
    noPadding?: boolean;
    dataid?: string;
    desktopAspectRatio?: string;
    tabletAspectRatio?: string;
    hitsResults?: algoliasearchHelper.SearchResults<BaseHit>;
};

export const M20Categories = memo(({ items, headline, priority, ...rest }: M20CategoriesModule) => {
    const leftArrow = useRef<HTMLButtonElement>(null);
    const rightArrow = useRef<HTMLButtonElement>(null);

    return (
        <>
            {!!items?.length && (
                <ModuleContainer {...rest}>
                    <CategoryCarousel
                        headline={headline}
                        leftArrow={leftArrow}
                        rightArrow={rightArrow}
                        priority={priority}
                        items={items}
                    />
                </ModuleContainer>
            )}
        </>
    );
});
